import type { SortConfig } from '../../lib/types'

export function SortableHeader({
  column,
  label,
  sortConfig,
  onSort
}: {
  column: string;
  label: string;
  sortConfig: SortConfig;
  onSort: (column: string) => void
}) {
  const isActive = sortConfig.column === column
  return (
    <th
      onClick={() => onSort(column)}
      className="cursor-pointer hover:bg-stone-200/50 dark:hover:bg-stone-700/50 select-none"
    >
      <div className="flex items-center gap-1">
        {label}
        <span className={`transition-opacity ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'}`}>
          {isActive && sortConfig.direction === 'asc' ? (
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </span>
      </div>
    </th>
  )
}
